import { render, staticRenderFns } from "./PainelDesenvolvimentoPessoas.vue?vue&type=template&id=5c2fcfff"
import script from "./PainelDesenvolvimentoPessoas.vue?vue&type=script&lang=js"
export * from "./PainelDesenvolvimentoPessoas.vue?vue&type=script&lang=js"
import style0 from "./PainelDesenvolvimentoPessoas.vue?vue&type=style&index=0&id=5c2fcfff&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports